import Alpine from 'alpinejs'

const data = (params = {}) => ({
  baseFontSize: '1.25', // rem
  smallCount: 0, // 已變小幾次
  enableLimit: false,
  maxSmallCount: 10,

  async init() {
    await this.$nextTick()
    this.detectFontsizeAndSmallize()
  },

  detectFontsizeAndSmallize() {
    this.smallCount = 0
    while(true) {
      const parentHeight = this.$el.parentNode.offsetHeight
      const currentHeight = this.$el.offsetHeight
      if (currentHeight <= parentHeight) { break }

      this.smallCount++
      this.$el.style.fontSize = `${this.baseFontSize - this.smallCount * 0.03125}rem`

      if (this.enableLimit && this.smallCount > this.maxSmallCount) { break }
    }
  },

  ...params
})

Alpine.data('detectFontsizeAndSmallize', data)

export default data
